<div class="health-bar" [ngClass]="{ critical: (entity().health + diff()) / maxHealth < 0.35 }">
  <div class="health-bar-value" [style.width]="((entity().health + diff()) / maxHealth) * 100 + '%'"></div>
</div>
